/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RunSummary } from './RunSummary';
import {
    RunSummaryFromJSON,
    RunSummaryFromJSONTyped,
    RunSummaryToJSON,
    RunSummaryToJSONTyped,
} from './RunSummary';

/**
 * 
 * @export
 * @interface DeviceDetail
 */
export interface DeviceDetail {
    /**
     * 
     */
    hostname: string;
    /**
     * 
     */
    runs: Array<RunSummary>;
    /**
     * 
     */
    lastSeenAt?: Date | null;
}

/**
 * Check if a given object implements the DeviceDetail interface.
 */
export function instanceOfDeviceDetail(value: object): value is DeviceDetail {
    if (!('hostname' in value) || value['hostname'] === undefined) return false;
    if (!('runs' in value) || value['runs'] === undefined) return false;
    return true;
}

export function DeviceDetailFromJSON(json: any): DeviceDetail {
    return DeviceDetailFromJSONTyped(json, false);
}

export function DeviceDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'hostname': json['hostname'],
        'runs': ((json['runs'] as Array<any>).map(RunSummaryFromJSON)),
        'lastSeenAt': json['last_seen_at'] === undefined ? undefined : json['last_seen_at'] === null ? null : (parseDateTime(json['last_seen_at'])),
    };
}

export function DeviceDetailToJSON(json: any): DeviceDetail {
    return DeviceDetailToJSONTyped(json, false);
}

export function DeviceDetailToJSONTyped(value?: DeviceDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostname': value['hostname'],
        'runs': ((value['runs'] as Array<any>).map(RunSummaryToJSON)),
        'last_seen_at': value['lastSeenAt'] == null ? value['lastSeenAt'] : serializeDateTime(value['lastSeenAt']),
    };
}

